/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./page-view-tracking.component";
import * as i2 from "@angular/router";
import * as i3 from "./tracking.service";
var styles_PageViewTrackingComponent = [];
var RenderType_PageViewTrackingComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_PageViewTrackingComponent, data: {} });
export { RenderType_PageViewTrackingComponent as RenderType_PageViewTrackingComponent };
export function View_PageViewTrackingComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, null, null, null, null, null, null, null))], null, null); }
export function View_PageViewTrackingComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "fl-page-view-tracking", [], null, null, null, View_PageViewTrackingComponent_0, RenderType_PageViewTrackingComponent)), i0.ɵdid(1, 114688, null, 0, i1.PageViewTrackingComponent, [i2.ActivatedRoute, i3.Tracking, i2.Router], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var PageViewTrackingComponentNgFactory = i0.ɵccf("fl-page-view-tracking", i1.PageViewTrackingComponent, View_PageViewTrackingComponent_Host_0, {}, {}, []);
export { PageViewTrackingComponentNgFactory as PageViewTrackingComponentNgFactory };
